import { Link, Outlet } from 'react-router-dom';

const RecruiterSignUpForm = () => {
  return (
    <>
      <div className="text-center mb-7">
        <h3 className="text-body-highlight">Sign Up</h3>
        <p className="text-body-tertiary">Recruit Top Talent Now!</p>
      </div>
      <Outlet />
      <div className="text-center">
        <Link to="/sign-in" className="fs-9 fw-bold">
          Sign in to an existing account
        </Link>
      </div>
    </>
  );
};

export default RecruiterSignUpForm;
